import React from 'react';

import './index.less';

interface Props {
  value: Array<any> | undefined;
}

const Index: React.FC<Props> = ({ value }) => {
  const renderPublish = (v: any, idx: number) => {
    if (idx < 5) {
      return (
        <img
          src={v}
          alt=""
          className="detail-publish-icon"
          key={idx}
          style={idx > 0 ? { position: 'relative', right: 6 * idx, zIndex: idx } : {}}
        />
      );
    } else if (idx === 5) {
      return (
        <div
          className="publish-icons"
          style={idx > 0 ? { position: 'relative', right: 6 * idx, zIndex: idx } : {}}
        >
          <span className="superapp_iconfont superapp_icon-shenglvehao" />
        </div>
      );
    } else {
      return;
    }
  };

  return (
    <div className="publish-container">{value?.map((item, idx) => renderPublish(item, idx))}</div>
  );
};

export default Index;
